import { render } from "./ApiLogs.vue?vue&type=template&id=88d9c48e&scoped=true"
import script from "./ApiLogs.vue?vue&type=script&lang=js"
export * from "./ApiLogs.vue?vue&type=script&lang=js"

import "./ApiLogs.vue?vue&type=style&index=0&id=88d9c48e&scoped=true&lang=css"

import exportComponent from "/private/var/www/html/goldenaces-club/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88d9c48e"]])

export default __exports__